<div class="code-search-spinner">
  <div class="code-search-main-load">
    <div class="cs-spinner">
      <mat-spinner></mat-spinner>
    </div>
    <div class="cs-loading-data" *ngIf="batch; else noLoadingTemplate">
      <div class="cs-batch">{{ batch }}</div>
      <div class="cs-progress">progress: {{ progress }}</div>
    </div>
    <ng-template #noLoadingTemplate>
      <div>{{ 'CODE_SEARCH.LOADING_IS_STARTING_TEXT' | translate }}</div>
    </ng-template>
  </div>
</div>
<div class="code-search-load-tip">
  <div>{{ 'CODE_SEARCH.LOADING_TIP' | translate }}</div>
</div>
